import { Reveal } from "@/components/Reveal";

export const PageHead = ({ eyebrow, title, sub, testid }) => (
  <section className="relative overflow-hidden py-16 sm:py-24">
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-primary mb-4">{eyebrow}</p>
          <h1
            data-testid={testid}
            className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.08]"
          >
            {title}
          </h1>
          {sub && (
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-muted-foreground">{sub}</p>
          )}
        </Reveal>
      </div>
    </div>
  </section>
);
